<h3 class="title-divider mb-1">{{ heading | translate }}</h3>
@if (mitBodenbedeckungsGeschichte) {
  <cap-form-control labelKey="BodenbedeckungGeschichte">
    <input
      (ngModelChange)="model && (model.bodenbedeckungGeschichte = $event)"
      [disabled]="disabled"
      [ngModel]="model && model.bodenbedeckungGeschichte"
      name="bodenbedeckungGeschichte"
      type="checkbox" />
  </cap-form-control>
}
<div class="mt-2" style="height: 450px; overflow: auto">
  <table class="cap-table-detail">
    <thead>
      <tr>
        <th>
          {{ "Art" | translate }}
        </th>
        <th>
          <cap-form-control [ngbTooltip]="'select.all' | translate" labelKey="Auswahl" placement="bottom-left">
            <input
              (change)="toggleAllCheckboxes()"
              [(ngModel)]="isToggleAll"
              [checked]="isAllChecked()"
              [disabled]="disabled"
              name="toggleAllCheckbox"
              type="checkbox" />
          </cap-form-control>
        </th>
      </tr>
    </thead>
    <tbody>
      @for (bedeckung of orderData; track bedeckung; let i = $index) {
        <tr (click)="addRemove(bedeckung, $event)">
          <td [class.text-muted]="disabled" class="noselect">
            {{ bedeckung.item.text | translateName }}
          </td>
          <td>
            <cap-form-control labelKey="NonBreakingSpace">
              <input
                (click)="addRemove(bedeckung, $event)"
                [disabled]="disabled"
                [id]="'BodenbedeckungArtEnum' + i"
                [ngModel]="bedeckung.checked"
                name="BodenbedeckungArtEnum"
                type="checkbox" />
            </cap-form-control>
          </td>
        </tr>
      }
    </tbody>
  </table>
</div>
